// ABOUTME: Global window.fetch wrapper adding the tab's active market header to same-origin API calls.
// ABOUTME: Installed once at bootstrap so every REST, download and auth call carries the header.

import { getActiveMarketId } from './activeMarketStore';
import { ACTIVE_MARKET_HEADER, MARKET_PATH_PREFIXES } from './constants';

const getRequestUrl = (input: RequestInfo | URL): string => {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    return input.url;
};

/**
 * True for a same-origin URL under one of the market path prefixes. External URLs, and anything
 * that cannot be parsed, never get the header.
 */
export const isMarketPath = (input: RequestInfo | URL, origin: string): boolean => {
    try {
        const url = new URL(getRequestUrl(input), origin);
        if (url.origin !== origin) return false;
        return MARKET_PATH_PREFIXES.some(
            prefix => url.pathname === prefix || url.pathname.startsWith(`${prefix}/`),
        );
    } catch {
        return false;
    }
};

/**
 * Wraps `window.fetch` so same-origin API calls carry `x-active-market`. A header set by the
 * caller wins. With no market stored (module off) the wrapper is a pass-through.
 */
export const installActiveMarketFetch = () => {
    const original = window.fetch.bind(window);
    window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
        const market = getActiveMarketId();
        if (!market || !isMarketPath(input, window.location.origin)) return original(input, init);
        const headers = new Headers(
            init?.headers ?? (input instanceof Request ? input.headers : undefined),
        );
        if (!headers.has(ACTIVE_MARKET_HEADER)) headers.set(ACTIVE_MARKET_HEADER, market);
        return original(input, { ...init, headers });
    };
};
